// extracted by mini-css-extract-plugin
export default {"animateWrapper":"styles_animateWrapper__MyQlN"};